import React from 'react';
import {Table, Typography} from "antd";
import { round2} from "../../utils/tools";

const { Text } = Typography;

const setBackgroundColor = (item) => {
  if (round2(item.solde) < round2(item.montantHT) || round2(item.solde) < 0) {
    return "editable-row row-edited-bg";
  } else {
    return "editable-row";
  }
};

const formatEuro = (value) =>
  (value || 0).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
  });

const TableSurrender = ({lignes, rowSelection, selectedRowsReddition}) => {

  const columns = [
    {
      title: "Code",
      dataIndex: "proprietaire_code",
      sorter: (a, b) => parseInt(a.proprietaire_code) - parseInt(b.proprietaire_code),
      width: "10%",
    },
    {
      title: "Lots",
      dataIndex: "lot_reference",
      sorter: (a, b) =>
        String(a.lot_reference ?? "").localeCompare(String(b.lot_reference ?? ""), "fr", {
          numeric: true,
          sensitivity: "base",
        }),
      render: (references = []) => references.join(" / ") || "—",
      width: "10%",
    },
    {
      title: "Nom",
      dataIndex: "proprietaire_nom",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.proprietaire_nom.localeCompare(b.proprietaire_nom),
      width: "15%",
    },
    {
      title: "Prénom",
      dataIndex: "proprietaire_prenom",
      width: "15%",
    },
    {
      title: "Montant hors honoraires",
      align: "right",
      dataIndex: "montantHT",
      render: (montantHT) => (
        <Text style={{ float: "right" }}>
          { formatEuro(montantHT) }
        </Text>
      ),
      width: "14%",
    },
    {
      title: "Montant honoraires",
      dataIndex: "montantFrais",
      align: "right",
      render: (montantFrais) => (
        <Text style={{ float: "right" }}>
          {formatEuro(montantFrais)}
        </Text>
      ),
      width: "12%",
    },
    {
      title: "Montant dû",
      dataIndex: "montantDu",
      align: "right",
      render: (montantDu) => (
        <Text style={{ float: "right" }}>
          {formatEuro(montantDu)}
        </Text>
      ),
      width: "10%",
    },
    /*{
      title: `Dettes locataires`,
      dataIndex: "dettesLocataires",
      render: (dettesLocataires) => (
        <Text style={{ float: "right" }}>
          {formatEuro(dettesLocataires)}
        </Text>
      ),
      width: "12%",
    },*/
    {
      title: "Solde à ce jour",
      dataIndex: "solde",
      align: "right",
      render: (solde) => (
        <Text style={{ float: "right" }}>
          {formatEuro(solde)}
        </Text>
      ),
      width: "10%",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={lignes}
      pagination={false}
      rowKey="proprietaire_id"
      rowSelection={{
        type: "checkbox",
        ...rowSelection,
      }}
      rowClassName={(record) => setBackgroundColor(record)}
      scroll={{ y: 252 }}
      showSorterTooltip={false}
      size="small"
      summary={() => {
        const totals = selectedRowsReddition.reduce(
          (acc, { montantHT, montantFrais, montantDu }) => ({
            ht: round2(acc.ht + parseFloat(montantHT || 0)),
            frais: round2(acc.frais + parseFloat(montantFrais || 0)),
            du: round2(acc.du + parseFloat(montantDu || 0)),
          }),
          { ht: 0, frais: 0, du: 0 }
        );

        return (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={4} />
              <Table.Summary.Cell index={4}>
                <strong>TOTAL :</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right">
                <strong>{formatEuro(totals.ht)}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6} align="right">
                <strong>{formatEuro(totals.frais)}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={7} align="right">
                <strong>{formatEuro(totals.du)}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={8} />
            </Table.Summary.Row>
          </Table.Summary>
        );
      }}
    />
  );
};

export default TableSurrender;
